<template>
    <div class="m-2">
        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Промокод</span>
            <span class="w-2/3">{{ entity.code }}</span>
        </div>

        <div v-if="entity.description" class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Описание</span>
            <span class="w-2/3">{{ entity.description }}</span>
        </div>

        <div v-if="entity.why_is_it_off"  class="flex items-center mt-4" style="color: red; font-weight: 600">
            <span class="w-1/3 font-bold">Причина создания (редактирования):</span>
            <span class="w-2/3">
                Причина: {{ entity.why_is_it_off }}.
                <br> Кто создал (редактировал): {{ entity.who_turned_off }}
                <br> Дата: {{ entity.shutdown_date }}
            </span>
        </div>

        <div
            v-if="
                (entity.restaurants && entity.restaurants.length > 0) ||
                    entity.all_restaurants
            "
            class="flex items-center mt-4"
        >
            <span class="w-1/3 font-bold">Рестораны</span>
            <span class="w-2/3">
                <span
                    v-if="entity.all_restaurants"
                    class="font-bold mr-3"
                >Все рестораны</span
                >
                <span
                    v-for="restaurant in entity.restaurants"
                    :key="restaurant"
                    class="text-purple-700 cursor-pointer hover:underline mr-3"
                    :title="allRestaurants[restaurant].title"
                    @click="$router.push(`/restaurants/${allRestaurants[restaurant].id}`)"
                >
                    {{ allRestaurants[restaurant].title }}
                </span>
            </span>
        </div>
        
        <div
            v-if="(entity.grocers && entity.grocers.length > 0) || entity.all_grocers"
            class="flex items-center mt-4"
        >
            <span class="w-1/3 font-bold">Магазины продуктов</span>
            <span class="w-2/3">
                <span
                    v-if="entity.all_grocers"
                    class="font-bold mr-3"
                >Все магазины продуктов</span
                >
                <span
                    v-for="grocer in entity.grocers"
                    :key="grocer"
                    class="text-purple-700 cursor-pointer hover:underline mr-3"
                    :title="allGrocers[grocer].title"
                    @click="$router.push(`/grocers/${allGrocers[grocer].id}`)"
                >
                    {{ allGrocers[grocer].title }}
                </span>
            </span>
        </div>

        <div
            v-if="(
                ((entity.entity_types && entity.entity_types.length > 0)
                    || (entity.entities && entity.entities.length))
                && (allEntityTypes && allEntityTypes.length)
            )">
            <div
                v-for="type of allEntityTypes"
                :key="type.id"
                class="flex items-center mt-4"
            >
                <span v-if="type.id" class="w-1/3 font-bold">{{ type.title }}</span>
                <span class="w-2/3">
                    <span
                        v-if="type.id && entity.entity_types && entity.entity_types.includes(type.id)"
                        class="font-bold mr-3"
                    >Все сервисы «{{ type.title }}»</span
                    >
                    <span
                        v-for="entity of type.services"
                        :key="entity.id"
                        class="text-purple-700 cursor-pointer hover:underline mr-3"
                        :title="entity.title"
                        @click="$router.push(`/entities/${type.code}/${entity.id}`)"
                    >
                        {{ entity.title }}
                    </span>
                </span>
            </div>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Минимальная сумма заказа</span>
            <span class="w-2/3">{{
                entity.min_sum ? entity.min_sum + " р." : ""
            }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Срок действия от:</span>
            <span class="w-2/3">{{
                entity.date_start ? formatDateShort(entity.date_start) : ""
            }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Срок действия до:</span>
            <span class="w-2/3">{{
                entity.date_finish ? formatDateShort(entity.date_finish) : ""
            }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Время жизни промокода (в днях)</span>
            <span class="w-2/3">{{
                entity.term_day ? entity.term_day : ""
            }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Количество заказов (разрешенное)</span>
            <span class="w-2/3">{{
                entity.term_count ? entity.term_count : ""
            }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Сколько максимально заказов может быть у пользователя, чтобы он смог применить промокод (0 - новички без заказов, 10000 - все смогут применить)</span>
            <span class="w-2/3">{{
                entity.max_term_count_for_user
            }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Сколько минимально заказов должно быть у пользователя, чтобы он смог применить промокод</span>
            <span class="w-2/3">{{
                entity.min_term_count_for_user
            }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Размер скидки (%)</span>
            <span class="w-2/3">{{
                entity.discount_percent ? entity.discount_percent + "%" : ""
            }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Размер скидки (руб.)</span>
            <span class="w-2/3">{{
                entity.discount_sum ? entity.discount_sum + " р." : ""
            }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Скидка от ресторана (%) </span>
            <span class="w-2/3">{{
                entity.entity_discount_percent ? entity.entity_discount_percent + "%" : ""
            }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Скидка от ресторана (руб.) </span>
            <span class="w-2/3">{{
                entity.entity_discount_sum ? entity.entity_discount_sum + " р." : ""
            }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Комиссия МИРСИТИ (%) </span>
            <span class="w-2/3">{{
                entity.mircity_commission ? entity.mircity_commission + "%" : ""
            }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Отправлять в интеграции (скидка от партнера)</span>
            <span class="w-2/3">
                <CBadge :color="entity.accounting_in_integration ? 'success' : 'secondary'">
                    {{ entity.accounting_in_integration ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Промокод для РЕФЕРАЛА</span>
            <span class="w-2/3">
                <CBadge :color="entity.for_referal ? 'success' : 'secondary'">
                    {{ entity.for_referal ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Промокод для РЕФЕРЕРА</span>
            <span class="w-2/3">
                <CBadge :color="entity.for_referer ? 'success' : 'secondary'">
                    {{ entity.for_referer ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Промокод для "Скидка за n-заказов"</span>
            <span class="w-2/3">
                <CBadge :color="entity.for_discount_on_orders ? 'success' : 'secondary'">
                    {{ entity.for_discount_on_orders ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Автоприменение промокода</span>
            <span class="w-2/3">
                <CBadge :color="entity.auto_apply ? 'success' : 'secondary'">
                    {{ entity.auto_apply ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div
            v-if="entity.auto_apply" 
            class="flex items-center mt-4">
            <span class="w-1/3 font-bold"> Приоритет автоприменения </span>
            <span class="w-2/3">{{ entity.priority }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Бесплатная доставка</span>
            <span class="w-2/3">
                <CBadge :color="entity.free_delivery ? 'success' : 'secondary'">
                    {{ entity.free_delivery ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Показать пользователям в списке</span>
            <span class="w-2/3">
                <CBadge :color="entity.show_customers ? 'success' : 'secondary'">
                    {{ entity.show_customers ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Создавать пользователю при регистрации</span>
            <span class="w-2/3">
                <CBadge :color="entity.generate_on_registration ? 'success' : 'secondary'">
                    {{ entity.generate_on_registration ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Использовать для награды за опросы</span>
            <span class="w-2/3">
                <CBadge :color="entity.generate_on_survey ? 'success' : 'secondary'">
                    {{ entity.generate_on_survey ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Тип доставки</span>
            <span class="w-2/3">
                {{ labelDeliveryType(entity.delivery_type) }}
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Активен</span>
            <span class="w-2/3">
                <CBadge :color="entity.enabled ? 'success' : 'secondary'">
                    {{ entity.enabled ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>
    </div>
</template>

<script>
    const { formatDate } = require('../../utils/views');
    const { DELIVERY_TYPE } = require('../../utils/order');
    const moment = require('moment');

    export default {
        props: {
            entity: {
                type: Object,
                default: () => {},
            },
        },

        data() {
            return {
                allRestaurants: [],
                allGrocers: [],
                allPharmacies: [],
                allAssistants: [],
                allEntityTypes: [],
            };
        },
        created() {
            this.initBusiness();
        },

        methods: {
            labelDeliveryType (delivery_type) {
                const types = [];
                types.push({ value: DELIVERY_TYPE.DOOR, label: 'До двери' });
                types.push({ value: DELIVERY_TYPE.MEETING_POINT, label: 'Место встречи' });
                types.push({ value: DELIVERY_TYPE.WITHOUT, label: 'Без доставки' });

                for (const type of types) {
                    if(delivery_type === type.value){
                        return type.label;
                    }
                }
                return '';
            },

            formatDate(date) {
                return formatDate(date);
            },

            async initBusiness() {
                // Restaurants
                var result = (await this.axios.get('/restaurants')).data;
                const restaurants = [];
                result.forEach(restaurant => {
                    restaurants[restaurant.id] = restaurant;
                });
                this.allRestaurants = restaurants;

                // Grocers
                result = (await this.axios.get('/grocers')).data;
                const grocers = [];
                result.forEach(grocer => {
                    grocers[grocer.id] = grocer;
                });
                this.allGrocers = grocers;

                // Pharmacies
                result = (await this.axios.get('/pharmacies')).data;
                const pharmacies = [];
                result.forEach(pharmacy => {
                    pharmacies[pharmacy.id] = pharmacy;
                });
                this.allPharmacies = pharmacies;

                // Assistants
                result = (await this.axios.get('/assistants')).data;
                const assistants = [];
                result.forEach(assistant => {
                    assistants[assistant.id] = assistant;
                });
                this.allAssistants = assistants;

                // Entities
                this.allEntityTypes = (await this.axios.get('/entities-type')).data;

                this.allEntityTypes = await Promise.all(this.allEntityTypes.map(async type => {
                    type.services = (await this.axios.get(`/entities/${type.code}`)).data;
                    return type;
                }));

                this.allEntityTypes = this?.allEntityTypes?.filter(type => {
                    const checkType = this.entity.entity_types.includes(type.id);
                    if (type?.services?.length) {
                        type.services = type.services.filter(entity => this.entity.entities.includes(entity.id));
                    }
                    return checkType || !!type.services.length;
                });
            },

            formatDateShort(data) {
                return moment(data).format('YYYY-MM-DD');
            },

        },
    };
</script>
